jQuery(document).ready(function($){
    $('.product-popup-btn:eq(0)').addClass('pop-btn-active');
    $('.product-popup-content:eq(0)').fadeIn();

    let swiper = new Swiper('.product-popup-images', {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: function () {
                let index = swiper.activeIndex;
                $('.product-popup-btn').removeClass('pop-btn-active');
                $('.product-popup-btn[data-index="' + index + '"]').addClass('pop-btn-active');
                $('.product-popup-content').hide();
                $('.product-popup-content[data-index="' + index + '"]').show();
                let input_val = $('.product-popup-btn[data-index="' + index + '"] a').text();
                let product_val = $('#SingleOptionSelector-1 input[value="'+ input_val +'"]');
                if (product_val.hasClass('disabled')) {
                    $('.product-popup-content[data-index="' + index + '"] .form-clicker').hide();
                }
                
            }
        }
    });
    $('.product-popup-btn').on('click', function(e) {
        e.preventDefault();
        let index = $(this).data('index');
        swiper.slideTo(index);
        $('.product-popup-btn').removeClass('pop-btn-active');
        $(this).addClass('pop-btn-active');
        $('.product-popup-content').hide();
        $('.product-popup-content[data-index="' + index + '"]').show();
    });
    $('.pop-titles a').on('click',function(e){
        e.preventDefault();
        $('.product-popup').removeClass('popup-active');
        $('.product-popup').fadeOut();
    });
    $('.popup-enter').on('click',function(e){ 
        e.preventDefault();
        $('.product-popup').css('display','flex').hide().fadeIn();
        $('.product-popup').addClass('popup-active');
        let index = $(this).data('index');
        swiper.slideTo(index);
        $('.product-popup-btn').removeClass('pop-btn-active');
        $('.product-popup-btn[data-index="'+ index +'"]').addClass('pop-btn-active');
        $('.product-popup-content').fadeOut();
        $('.product-popup-content[data-index="' + index + '"]').fadeIn();
    });
    let input_checked = $('#SingleOptionSelector-1 input:checked').val();
    let checked_val = input_checked.replace(/ /g, '-').toLowerCase();
    $('.popup-'+checked_val).css('display','flex').fadeIn();
    $('#SingleOptionSelector-1 label').on('click',function(){
        let input_val = $(this).prev('input').val();
        let value_input = input_val.replace(/ /g, '-').toLowerCase();
        $('.popup-infos').hide();
        $('.popup-'+value_input).css('display','flex').show();
    });

    $('.popup-action').insertAfter('#SingleOptionSelector-1');

    $('.pop-overlay').on('click',function(){
        if ($('.product-popup').hasClass('popup-active')) {
            $('.product-popup').removeClass('popup-active');
            $('.product-popup').fadeOut();
        }
    });
    $(document).on('keydown', function(e) {
        if ($('.product-popup').hasClass('popup-active')) {
            if (e.keyCode === 27) { 
                $('.product-popup').removeClass('popup-active');
                $('.product-popup').fadeOut(); 
            }
        }
    });
    $('.form-clicker a').on('click',function(e){
        e.preventDefault();
        let val_index = $(this).parent().parent().data('index');
        let text_val = $('.product-popup-btn[data-index="' + val_index + '"] a').text();
        let product_val = $('#SingleOptionSelector-1 input[value="'+ text_val +'"]').attr('id');
        $('#SingleOptionSelector-1 label[for="'+product_val+'"]').trigger('click');
        $('.product-popup').removeClass('popup-active');
        $('.product-popup').hide();
    

    }); 
});